var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 505",
    style: {
      enableBackground: "new 0 0 505 505"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 252.5,
    cy: 252.5,
    r: 252.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M379.9,430.1H125.1c-2.6,0-4.7-2.1-4.7-4.7V102.5c0-2.6,2.1-4.7,4.7-4.7H380c2.6,0,4.7,2.1,4.7,4.7 v323C384.6,428,382.5,430.1,379.9,430.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "146.4,116.8 146.4,379.6 321.6,379.6 321.6,342.7 358.6,342.7 358.6,116.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E9EE"
    },
    points: "321.6,379.6 358.6,342.7 321.6,342.7 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M273.3,87.2v-7.3c0-11.5-9.3-20.8-20.8-20.8c-11.5,0-20.8,9.3-20.8,20.8v7.3H195v42.6h115.1V87.2 H273.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 252.5,
    cy: 79.9,
    r: 10.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M295.1,309.1H176.6V190.6h118.5V309.1z M188.3,297.5h95.2v-95.2h-95.2V297.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#54C0EB"
    },
    points: "243.9,285.4 200.3,241.8 220.9,221.2 243.9,244.2 307.8,180.4 328.4,201 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4ce4ef225f69d4bc8d91000ad0d13948.svg";
export { ForwardRef as ReactComponent };